export const kipState = {
    updateRequest: 0
};

export const kipReducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_REQUEST':
            return {
                ...state,
                updateRequest: action.payload
            };
        default:
            return state;
    }
};
